module.exports = __webpack_public_path__ + "static/media/firebase-logo.264b4af3.png";